var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTranslation)?_c('div',{staticClass:"probability column",class:_vm.probabilityClass},[_vm._v(" "+_vm._s(_vm.$t(_vm.probabilityText))+" ")]):_c('div',{staticClass:"probability column",class:_vm.probabilityClass},[_vm._v(" "+_vm._s(_vm.probabilityText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }